import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import EconomicActivities from '../pages/EconomicActivity/EconomicActivities';
import SupplierPage from '../pages/Supplier/SupplierPage';
import BasePurchasePage from '../pages/Purchase/register/BasePurchasePage';
import PurchaseHistory from '../pages/Purchase/history/PurchaseHistory';
import PurchaseCancel from '../pages/Purchase/cancel/PurchaseCancel';
import ProtectedRouteV2 from './ProtectedRouteV2';

const purchaseRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/purchase-register"
      element={
        <>
          <PageTitle title="Registrar Compra | POS System" />
          <BasePurchasePage />
        </>
      }
    />

    <Route
      path="/purchase-history"
      element={
        <>
          <PageTitle title="Historial de Compras | POS System" />
          <PurchaseHistory />
        </>
      }
    />
   
    <Route
      path="/purchase-cancel"
      element={
        <>
          <PageTitle title="Anular Compra | POS System" />
          <PurchaseCancel />
        </>
      }
    />

    <Route
      path="/suppliers"
      element={
        <>
          <PageTitle title="Proveedores | POS System" />
          <SupplierPage />
        </>
      }
    />

    <Route
      path="/economic-activities"
      element={
        <>
          <PageTitle title="Actividades Económicas | POS System" />
          <EconomicActivities />
        </>
      }
    />
  </Route>
);

export default purchaseRoutes;
